import { createMiddleware } from '@shared/redux';
import { LOCATION_CHANGE } from 'connected-react-router';
import { analytics } from '../analytics';

export const routerMiddleware = createMiddleware({
    [LOCATION_CHANGE]: async () => {
        analytics.page();
    },
}, { beforeChanges: true });
